import React from 'react';
import Lottie from 'lottie-react';
import spinnerAnimation from '../assets/animations/spinner.json';
import { useMediaQuery } from 'react-responsive';
import { constantStyles } from '../constants/constantStyles';

const ImageSpinner = ({overrideSizeStyles, extraStyles}) => {
    const isMobile = useMediaQuery({ maxWidth: constantStyles.mobileWidth });

    const size = isMobile ? 100 : 150;
    const styleSize  = overrideSizeStyles ?? { width: size, height: size };

    return (
        <Lottie
          animationData={spinnerAnimation}
          loop={true}
          style={{...styleSize, ...extraStyles}}
        />
    );
  };

export default ImageSpinner;